'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var React = require('react');
var classNames = require('classnames');
var HCCard = require('../Cards/HCCard.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var style = function style(theme) {
  return {
    root: {
      flexGrow: 1
    },
    card: {
      width: 249
    },
    containerBlueBorder: {
      borderRadius: 4,
      boxShadow: "0px 0px 0px 2px ".concat(theme.palette.primary.main)
    },
    empty: {
      boxShadow: 'none'
    },
    emptyDefault: {
      borderRadius: 4,
      border: "1px solid ".concat(theme.palette.divider)
    },
    header: {
      padding: 16,
      color: 'black'
    },
    bodyImage: {
      width: '100%',
      height: 170,
      backgroundColor: theme.palette.brandPrimary.light
    },
    bodyDescription: {
      padding: 16,
      minHeight: '218px'
    },
    footerTotal: {
      minHeight: '56px'
    },
    footerButton: {
      padding: '16px 0px 24px 0px'
    },
    contentContainer: {
      height: '100%'
    }
  };
};

var OptionCard = function OptionCard(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      image = _ref.image,
      description = _ref.description,
      subtotal = _ref.subtotal,
      total = _ref.total,
      button = _ref.button,
      isActive = _ref.isActive,
      isEmpty = _ref.isEmpty,
      isHovered = _ref.isHovered,
      cardProps = _ref.cardProps,
      lendingPromo = _ref.lendingPromo;
  var containerClass = isActive || isHovered ? classNames__default["default"](classes.card, classes.containerBlueBorder) : isEmpty ? classNames__default["default"](classes.card, classes.empty, classes.emptyDefault) : classes.card;
  return React__default["default"].createElement("div", {
    className: classes.root
  }, React__default["default"].createElement(HCCard, _extends["default"]({
    className: containerClass
  }, cardProps), React__default["default"].createElement(Grid["default"], {
    container: true,
    alignContent: "space-between",
    className: classes.contentContainer
  }, React__default["default"].createElement(Grid["default"], {
    container: true,
    item: true,
    xs: 12
  }, React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12,
    className: classes.header
  }, title), React__default["default"].createElement(Grid["default"], {
    item: true,
    container: true
  }, React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12,
    className: classes.bodyImage
  }, image), React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12,
    className: classes.bodyDescription
  }, description))), React__default["default"].createElement(Grid["default"], {
    container: true,
    item: true,
    xs: 12,
    className: classes.footerTotal
  }, lendingPromo, React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12
  }, total), subtotal && React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12
  }, subtotal), React__default["default"].createElement(Grid["default"], {
    container: true,
    justify: "center",
    item: true,
    xs: 12,
    className: classes.footerButton
  }, button)))));
};

var OptionCard$1 = withStyles(style)(OptionCard);
OptionCard.defaultProps = {
  isActive: false,
  isEmpty: false,
  isHovered: false
};

module.exports = OptionCard$1;
